import React, { Component, Suspense } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { Card } from "reactstrap";
import { Menu, Segment, Sidebar, Dropdown } from "semantic-ui-react";
import {
  Skeleton,
  DatePicker,
  Menu as MenuAnt,
  Dropdown as Dropdown2,
  Modal,
  Button as ButtonAnt,
} from "antd";
import Fade from "react-reveal/Fade";
import { connect } from "react-redux";
import { Services } from "./Services";
import axios from "axios";
import _ from "lodash";
import { IconNewComment } from "./components/img";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Table from "./../Components/Table";
import Loader from "./../../Global/Loader";
import { ShowForRole } from "../../Global/Permission";
import { FilterForRole } from "../../Global/Permission/filter";
import { moduleActions } from "../../Global/Permission/constants";
import FormFiltros from "./model/form";
import createModal from "../Components/ModalV2";
import { Link } from "react-router-dom";
import { openNotification } from "../Components/Notification";

import { withNamespaces } from "react-i18next";
const Comments = React.lazy(() => import("../Components/Comments"));

const dateNow = new Date();

const { RangePicker } = DatePicker;
const styles = {
  background: "red",
};
const KeysFilter = [
  {
    id: "Status",
    tipo: "UseIN",
  },
  {
    id: "CustomerName",
    tipo: "UseIN",
  },
  {
    id: "SupplierName",
    tipo: "UseIN",
  },
  {
    id: "ConsigneeName",
    tipo: "UseIN",
  },
  {
    id: "TransportMode",
    tipo: "UseIN",
  },
  {
    id: "SOCreationDate",
    tipo: "isDate",
  },
  {
    id: "PromiseCargoReadyDate",
    tipo: "isDate",
  },
  {
    id: "EstCargoReadyDate",
    tipo: "isDate",
  },
  {
    id: "ActualCargoReadyDate",
    tipo: "isDate",
  },
  {
    id: "RequiredDateDestination",
    tipo: "isDate",
  },
];

class OrderListCommponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameXlsx: `${this.props.t("order_list")} - ${dateNow.getFullYear() +
        "" +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        "" +
        dateNow.getDate().toString().padStart(2, "0")
        }.xlsx`,
      isMovil: false,
      deleteMessage: false,
      loadercomments: false,
      viewModalComments: false,
      commentsData: [],
      users: [],
      rolId: this.props._rolId,
      userId: this.props._user,
      serviceOrderId: undefined,
      scrollLine: false,
      orders: [],
      data: [],
      advancedObj: [],
      catalogCombo: [],
      advancedSearch: {},
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      activePage: 1,
      limit: 10,
      numberPage: 1,
      filtros: "",
      filterOpen: false,
      url: "",
      loading: true,
      columns: [
        {
          label: "",
          id: "commentView",
          key: "commentViewAction",
          minWidth: 45,
          maxWidth: 45,
          noclick: true,
          custom: (value, triggerFn) => (
            <div title={this.props.t("comments")}
              onClick={() => {
                this.setState(
                  {
                    loadercomments: true,
                    viewModalComments: true,
                  },
                  () => this.getCommnets(value)
                );
              }}
            >
              {value.NewComments ? (
                <IconNewComment></IconNewComment>
              ) : (
                <span className="icon-comments icons-front-module" />
              )}
            </div>
          ),
        },
        {
          label: "",
          key: "",
          minWidth: 45,
          maxWidth: 45,
          custom: (value) => {
            return value.aviableDiscardStatus ? (
              <ShowForRole
                rol={this.props._rolId}
                moduleAction={moduleActions.PEDIDO_ACCIONES}
              >
                <Dropdown2
                  noResultsMessage={this.props.t("no_results_found")}
                  overlay={
                    <MenuAnt vertical>
                      <FilterForRole
                        rol={this.props._rolId}
                        userId={this.props._user}
                        moduleAction={moduleActions.PEDIDO_DUPLICAR}
                        userCreatedId={value.UserCreateId}
                      >
                        <MenuAnt.Item
                          className="label-euro"
                          onClick={() => this.discardOrder(value, "duplicar")}
                        >{this.props.t("duplicate")}
                        </MenuAnt.Item>
                      </FilterForRole>
                      <FilterForRole
                        rol={this.props._rolId}
                        userId={this.props._user}
                        moduleAction={moduleActions.PEDIDO_CANCELAR}
                        userCreatedId={value.UserCreateId}
                      >
                        <MenuAnt.Item
                          className="label-euro"
                          onClick={() => this.discardOrder(value, "cancelar")}
                        >
                          {this.props.t("cancel")}
                        </MenuAnt.Item>
                      </FilterForRole>
                      <FilterForRole
                        rol={this.props._rolId}
                        userId={this.props._user}
                        moduleAction={moduleActions.PEDIDO_ELIMINAR}
                        userCreatedId={value.UserCreateId}
                      >
                        <MenuAnt.Item
                          className="label-euro"
                          onClick={() => this.discardOrder(value, "delete")}
                        >
                          {this.props.t("delete")}
                        </MenuAnt.Item>
                      </FilterForRole>
                    </MenuAnt>
                  }
                  placement="topRight"
                >
                  <span className="icon-po-visibility-tablemenu icons-front-module" />
                </Dropdown2>
              </ShowForRole>
            ) : (
              <ShowForRole
                rol={this.props._rolId}
                moduleAction={moduleActions.PEDIDO_ACCIONES}
              >
                <Dropdown2
                  overlay={
                    <MenuAnt>
                      <FilterForRole
                        rol={this.props._rolId}
                        userId={this.props._user}
                        moduleAction={moduleActions.PEDIDO_DUPLICAR}
                        userCreatedId={value.UserCreateId}
                      >
                        <MenuAnt.Item
                          className="label-euro"
                          onClick={() => this.discardOrder(value, "duplicar")}
                        >
                          {this.props.t("duplicate")}
                        </MenuAnt.Item>
                      </FilterForRole>
                    </MenuAnt>
                  }
                  noResultsMessage={this.props.t("no_results_found")}
                  placement="topRight"
                >
                  <span className="icon-po-visibility-tablemenu icons-front-module" />
                </Dropdown2>
              </ShowForRole>
            );
          },
        },
        {
          label: this.props.t("reference_po"),
          key: "RefCustomer",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            <Link
              to={"/so-detail-view/" + value.ServiceOrderId}
              className="underline-link"
            >
              {value.RefCustomer}
            </Link>
          ),
        },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            // <Button  className={value.StatusId === 13 ? 'btn-estatus btn-oval _gray_button' : ' btn-estatus btn-oval'} color={mapColor[value.StatusId] ? mapColor[value.StatusId] : 'complementary'} onClick={() => { }}>{value.Status}</Button>
            <span class="badge badge-euro">{value.Status}</span>
          ),
        },
        { label: this.props.t("company"), key: "CustomerName", minWidth: 200 },
        { label: this.props.t("shipper"), key: "SupplierName", minWidth: 200 },
        {
          label: this.props.t("consignee"),
          key: "ConsigneeName",
          minWidth: 200,
        },
        {
          label: this.props.t("transport_mode"),
          key: "TransportMode",
          minWidth: 180,
        },
        {
          label: this.props.t("amounts_ordered"),
          key: "QTYOrdered",
          minWidth: 150,
          custom: (value) => (
            <span>{Number(value.QTYOrdered).toLocaleString("En-us")}</span>
          ),
        },
        {
          label: this.props.t("creation_date"),
          key: "SOCreationDate",
          minWidth: 150,
        },
        {
          label: this.props.t("required_at_destination"),
          key: "RequiredDateDestination",
          minWidth: 180,
        },
        {
          label: this.props.t("cargo_ready_commitment_date"),
          key: "PromiseCargoReadyDate",
          minWidth: 200,
        },
        {
          label: this.props.t("cargo_ready_est"),
          key: "EstCargoReadyDate",
          minWidth: 150,
        },
        {
          label: this.props.t("actual_cargo_ready"),
          key: "ActualCargoReadyDate",
          minWidth: 150,
        },
        {
          label: this.props.t("arrive_at_final_destination"),
          key: "FinalDestinationArrivalDate",
          minWidth: 200,
        },
      ],
      customXlsColumns: [
        {
          label: this.props.t("reference_purchase_order"),
          key: "RefCustomer",
        },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 150,
          maxWidth: 200,
        },
        { label: this.props.t("company"), key: "CustomerName", minWidth: 180 },
        { label: this.props.t("shipper"), key: "SupplierName", minWidth: 180 },
        {
          label: this.props.t("consignee"),
          key: "ConsigneeName",
          minWidth: 180,
        },
        {
          label: this.props.t("transport_mode"),
          key: "TransportMode",
          minWidth: 180,
        },
        { label: this.props.t("incoterm"), key: "Incoterm", minWidth: 100 },
        {
          label: this.props.t("amounts_ordered"),
          key: "QTYOrderedFormatted",
          minWidth: 150,
        },
        {
          label: this.props.t("creation_date"),
          key: "SOCreationDate",
          minWidth: 150,
        },
        {
          label: this.props.t("required_at_destination"),
          key: "RequiredDateDestination",
          minWidth: 150,
        },
        {
          label: this.props.t("cargo_ready_commitment_date"),
          key: "PromiseCargoReadyDate",
          minWidth: 150,
        },
        {
          label: this.props.t("cargo_ready_est"),
          key: "EstCargoReadyDate",
          minWidth: 100,
        },
        {
          label: this.props.t("actual_cargo_ready"),
          key: "ActualCargoReadyDate",
          minWidth: 100,
        },
        {
          label: this.props.t("arrive_at_final_destination"),
          key: "FinalDestinationArrivalDate",
          minWidth: 100,
        },
      ],
      searchOnInit: false,
      searchText: "",
      POId: 0,
      openComments: false,
      handleResCom: "unset",
      isSearchComments: true,
      tableLoader: false,
      AddSO: (
        <div className="float-right">
          <Button
            color="primary"
            className="d-flex align-items-center"
            title={this.props.t("create_new")}
            onClick={() => {
              this.addServiceOrder();
            }}
          >
            <span className="icon-plus icon-button-add" />
            {this.props.t("create_new")}
          </Button>
        </div>
      ),
      modalOpen: false,
      textModal: "",
      typeAction: "",
      modalSuccess: false,
      duplicatedPoId: undefined,
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    this.setState({
      isMovil: isMobileDevice,
    });

    await this.createFilter();
    await this.getOrdersList();
    await this.getCatalogs();
  };
  componentDidUpdate = (nextProps) => {
    //this.getOrdersList();
  };

  getCommnets = (item, NewComments) => {
    let { CustomerId, ServiceOrderId } = item;

    let moduleId = 2;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/get-comment?rowid=${ServiceOrderId}&moduleid=${moduleId}&general=false&zona=${timezone}&lang=${this.props.lng}`
      )
      .then((response) => {
        let comentario = response.data.Comment;
        this.getUserMenciones(comentario, CustomerId, ServiceOrderId, item);

        if (NewComments) {
          openNotification('success', NewComments);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserMenciones = (comentario, CustomerId, ShipmentId, item) => {
    let { userId } = this.state;
    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/getUserMension?CustomerId=${CustomerId}&user=${userId}`
      )
      .then((response) => {
        this.setState({
          commentsData: comentario,
          users: response.data.data,
          rowid: ShipmentId,
          itemCommenSelect: item,
          loadercomments: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  newMessage = async (data) => {
    let { userId, rowid, itemCommenSelect } = this.state;

    data.Rowid = rowid;
    data.UserId = userId;
    data.ModuleId = 2;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.ORDEN_SERV.path}orderComents/add-comment`, data)
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_saved")
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteMessage = async (idDelete, toggle) => {
    let { itemCommenSelect } = this.state;
    if (!this.state.deleteMessage) {
      axios
        .delete(
          `${Services.ORDEN_SERV.path}orderComents/delete-comment/${idDelete}`
        )
        .then((response) => {
          this.setState({ deleteMessage: true }, () => {
            this.getCommnets(
              itemCommenSelect,
              this.props.t("comment_successfully_deleted")
            );
            toggle()
            setTimeout(() => {
              this.setState({ deleteMessage: false });
            }, 1000);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  createFilter = async () => {
    let { advancedSearch } = this.state;
    advancedSearch = FormFiltros.map((filtro) => {
      return {
        id: filtro.id,
        isDate: filtro.type == "Datetime",
        UseIN: filtro.type == "Select",
        value: "",
        type: filtro.type,
        label: filtro.label,
        name: filtro.name,
        class: filtro.class,
        style: filtro.style,
      };
    });
    this.setState({ advancedSearch });
  };

  discardOrder = (value, tipo) => {

    this.setState({ serviceOrderId: value.ServiceOrderId, typeAction: tipo })

    if (tipo == "cancelar") {
      this.setState({ textModal: this.props.t("are_you_sure_cancel") })
    } else if (tipo == "duplicar") {
      this.setState({ textModal: this.props.t("are_you_sure_duplicate") })
    } else {
      this.setState({ textModal: this.props.t("are_you_sure_delete") })
    }

    this.toggle()

    //   onOk: () => {
    //     if (tipo == "cancelar") {
    //       axios
    //         .put(
    //           `${Services.ORDEN_SERV.path}orden/cancelOrder/${serviceOrderId}`,
    //           {
    //             data: {
    //               UserId,
    //             },
    //           }
    //         )
    //         .then((success) => {
    //           this.getOrdersList();
    //         })
    //         .catch((error) => {
    //           console.warn(error);
    //         });
    //     } else if (tipo == "duplicar") {
    //       axios
    //         .post(
    //           `${Services.ORDEN_SERV.path}orden/duplicarOrder/${serviceOrderId}`,
    //           {
    //             data: {
    //               UserId,
    //             },
    //           }
    //         )
    //         .then((success) => {
    //           this.sendMessage(this.props.t("success_duplicated"), "success");
    //           console.log(success.data);
    //           this.props.history.push("/so-detail-view/" + success.data.data);
    //         })
    //         .catch((error) => {
    //           console.warn(error);
    //         });
    //     } else {
    //       axios
    //         .delete(
    //           `${Services.ORDEN_SERV.path}orden/deleteOrder/${serviceOrderId}`,
    //           {
    //             data: {
    //               UserId,
    //             },
    //           }
    //         )
    //         .then((success) => {
    //           this.getOrdersList();
    //         })
    //         .catch((error) => {
    //           console.warn(error);
    //         });
    //     }
    //   },
    //   onCancel() {
    //     console.log("Cancel");
    //   },
    // });
  };

  cancelPo = async () => {
    let { serviceOrderId, userId } = this.state;
    let UserId = userId

    try {
      axios.put(`${Services.ORDEN_SERV.path}orden/cancelOrder/${serviceOrderId}`, { data: { UserId }, })
        .then(() => {
          this.getOrdersList();
          this.setState({ modalOpen: false })
        })
        .catch((error) => {
          console.warn(error);
        });
    } catch (error) {
      console.log("🚀 ~ cancelPo= ~ error:", error)
    }
  };

  duplicatePo = async () => {
    let { serviceOrderId, userId } = this.state;
    let UserId = userId

    try {
      axios.post(`${Services.ORDEN_SERV.path}orden/duplicarOrder/${serviceOrderId}`, { data: { UserId } })
        .then((success) => {
          this.setState({ modalSuccess: true, modalOpen: false, duplicatedPoId: success.data.data })
        })
        .catch((error) => {
          console.warn(error);
        });
    } catch (error) {
      console.log("🚀 ~ duplicatePo= ~ error:", error)
    }
  };

  deletePo = async () => {
    let { serviceOrderId, userId } = this.state;
    let UserId = userId

    try {
      axios.delete(`${Services.ORDEN_SERV.path}orden/deleteOrder/${serviceOrderId}`, { data: { UserId } })
        .then(() => {
          this.getOrdersList();
          this.setState({ modalOpen: false })
        })
        .catch((error) => {
          console.warn(error);
        });
    } catch (error) {
      console.log("🚀 ~ deletePo ~ error:", error)
    }
  };

  toggle = () => this.setState({ modalOpen: !this.state.modalOpen })
  toggleCancel = () => this.setState({ modalOpen: false, modalSuccess: false })


  resetAdvance = () => {
    let { advancedSearch } = this.state;
    advancedSearch.map((advData) => {
      if (advData.type == "Datetime") {
        advData.value = "";
        advData.valueD = "";
      } else {
        advData.value = [];
      }
    });
    this.setState({ advancedSearch }, () => {
      this.getOrdersList();
      this.generateFilters();
    });
  };
  generateFilters = () => {
    let { catalogCombo, advancedSearch } = this.state;
    let { t } = this.props;
    let Inputs = [];
    Inputs.push(
      <div className="col-12 ">
        <span
          class="icon-clear icons-front-module float-right"
          // style={{
          //   marginTop: "7px",
          //   cursor: "pointer",
          //   textAlign: "end",
          // }}
          title={t("eliminate_filter")}
          onClick={this.resetAdvance}
        />
      </div>
    );
    Inputs.push(
      advancedSearch.map((e, i) => {
        if (e.type === "Select")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  {t(e.label)}
                  {e.required === true ? (
                    <span style={{ color: "#ff0000" }}>*</span>
                  ) : (
                    ""
                  )}
                </span>
              </Fade>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Dropdown
                  noResultsMessage={t("no_results_found")}
                  className=""
                  onChange={this.handleChangeSelect(e.id)}
                  id={e.id}
                  options={catalogCombo[e.id]}
                  clearable
                  search
                  selection
                  fluid
                  value={e.value}
                  multiple
                  allowAdditions
                />
              </div>
            </div>
          );
        else if (e.type === "Datetime") {
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                <span id={t(e.label)} style={e.style}>
                  {t(e.label)} {e.required == true ? <span>*</span> : ""}{" "}
                </span>
              </Fade>
              <RangePicker
                onChange={this.handleChangeDate(e.id)}
                size="middle"
                className="col-md-12"
                value={e.valueD}
                placeholder={[t("start_date"), t("end_date")]}
              />
              <Fade left opposite>
                <label style={e.style}>{e.error}</label>
              </Fade>
            </div>
          );
        }
      })
    );

    this.setState({
      filtros: Inputs,
    });
  };

  handleChangeSelect = (selected) => (evt, data) => {
    let { advancedSearch } = this.state;
    if (data.value) {
      advancedSearch.map((search) => {
        if (search.id == selected) {
          search.value = data.value;
        }
      });
    } else {
      advancedSearch.map((search) => {
        if (search.id == selected) {
          search.value = "";
        }
      });
    }
    this.setState({ advancedSearch, numberPage: 1 }, () => {
      this.generateFilters();
      this.getOrdersList();
    });
  };

  handleChangeDate = (name) => (event) => {
    let { advancedSearch } = this.state;

    try {
      advancedSearch.map((search) => {
        if (search.id == name) {
          let init = event ? event[0].format("YYYY-MM-DD") : "";
          let end = event ? event[1].format("YYYY-MM-DD") : "";
          search.value = { init, end };
          search.valueD = event ? [event[0], event[1]] : "";
          search.isDate = true;
        }
      });
      this.setState({ advancedSearch, numberPage: 1 }, () => {
        this.generateFilters();
        this.getOrdersList();
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  getCatalogs = async () => {
    let { catalogCombo } = this.state;
    let data = {
      client: this.state.clientesSelect,
      userId: this.state.userId,
      lang: this.props.lng,
    };
    try {
      let success = await axios.post(
        `${Services.ORDEN_SERV.path}orden/filterCatalog`,
        data
      );
      catalogCombo = success.data.data;
      this.setState(
        {
          catalogCombo,
          loading: false,
        },
        () => {
          this.generateFilters();
        }
      );
    } catch (error) {
      console.warn(error);
    }
  };
  addServiceOrder = () => {
    this.props.history.push("/add-so");
  };

  /*=============================================
  =            Get Order List                   =
  =============================================*/

  getOrdersList = async () => {
    let sendData = {};
    //limpiar valores
    if (this.state.advancedObj && this.state.advancedObj.length > 0) {
      this.state.advancedObj.map((obj) => {
        if (obj.UseIN) {
          let data = [];
          if (obj.value && obj.value.length > 0) {
            obj.value.map((d) => {
              data.push(d.split("_")[0]);
            });
          }
          obj.value = _.cloneDeep(data);
        }
      });
    }
    sendData = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      EsDTA: 0,
      search: this.state.search,
      query: { allData: true },
      advanced: this.state.advancedSearch,

      lang: this.props.lng,
      userId: this.state.userId,
    };
    this.setState({
      url: encodeURI(
        `${Services.ORDEN_SERV.path}orden/listOrders?search=${this.state.search}&allData=true`,
        {
          lang: this.props.lng,
          userId: this.state.userId,
        }
      ),
      paramsxml: sendData,
    });

    // // axios.post(`${Services.Get_Traceability_Shipments.path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {

    try {
      let success = await axios.post(
        `${Services.ORDEN_SERV.path}orden/listOrders`,
        sendData
      );
      let data = success.data.data.map((e) => {
        let TraspormodeId = 1;
        e.TraspormodeId = TraspormodeId;
        e.QTYOrderedFormatted = Number(e.QTYOrdered).toLocaleString("En-us");
        return e;
      });
      this.setState({
        totalPages: success.data.totalPage,
        totalPagesExt: success.data.totalPage,
        data: data,
        dataAux: data,
        dataOut: data,
        loading: false,
        // fullLoader: true
      });
    } catch (error) {
      console.log(error);
      console.warn(error);
    }
  };

  resetTable = () => {
    this.setState({ isSearchComments: false, handleResCom: "unset" }, () => {
      this.getOrdersList();
    });
  };

  /*=============================================
  =            Selected Order                   =
  =============================================*/

  selectedOrder = (order) => {
    this.setState({
      POId: order.POId,
      PONumber: order.PONumber,
      openComments: true,
      handleResCom: "set",
      isSearchComments: true,
    });
  };

  handleClose = () => {
    this.setState({ openComments: false, isSearchComments: false });
  };

  setAdvanced = () => {
    let { filterOpen } = this.state;
    this.setState({ filterOpen: !filterOpen }, () => { });
  };
  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      viewModalComments,
      loadercomments,
      commentsData,
      itemCommenSelect,
      users,
      rolId,
      userId,
      scrollLine,
      data,
      columns,
      loading,
      searchOnInit,
      searchText,
      handleResCom,
      advancedSearch,
      filtros,
      customXlsColumns,
      isMovil,
      modalOpen,
      textModal,
      typeAction,
      modalSuccess,
      duplicatedPoId,
    } = this.state;

    return (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-po-visibility icon-header" />
          {this.props.t("orderVisibility")}
        </div>
        <Card className="myCard">
          {loading ? (
            <Loader />
          ) : (
            <Row>
              <Col md={12} xl={12}>
                <Suspense fallback={<div>Loading...</div>}>
                  <Sidebar.Pushable as={Segment}>
                    <Sidebar
                      as={Menu}
                      animation="overlay"
                      icon="labeled"
                      style={{
                        maxHeight: "84%!important",
                        width: isMovil
                          ? window.innerWidth - window.innerWidth * 0.09
                          : 400,
                      }}
                      direction="right"
                      vertical
                      id="sidebarComents"
                      visible={viewModalComments}
                      className="custom-sidebar"
                    >
                      <div className=" col-12 close_container">
                        <div className="header_comments">
                          {itemCommenSelect
                            ? itemCommenSelect.RefCustomer
                            : ""}
                        </div>
                        <div
                          className="close_icon2"
                          onClick={() => {
                            this.setState({ viewModalComments: false });
                          }}
                        >
                          <ButtonAnt
                            size="small"
                            type="primary"
                            shape="circle"
                          >
                            X
                          </ButtonAnt>
                        </div>
                      </div>
                      <div style={{ height: "3em" }} className=" col-12">
                        {" "}
                      </div>

                      {loadercomments === true ? (
                        <Skeleton active paragraph={{ rows: 17 }} />
                      ) : (
                        <div className="col-12">
                          <Comments
                            commentTableList={true}
                            rolId={rolId}
                            userId={userId}
                            data={commentsData}
                            catalogs={users}
                            scrollLine={scrollLine}
                            funtionNewMessage={this.newMessage}
                            funtionDeleteMessage={this.deleteMessage}
                          />
                        </div>
                      )}
                    </Sidebar>
                    <Sidebar.Pusher>
                      <Segment basic>
                        <Table
                          columns={columns}
                          customXlsColumns={customXlsColumns}
                          toFilter={KeysFilter}
                          nameXlsx={this.state.nameXlsx}
                          data={data}
                          advancedSearchData={advancedSearch}
                          advanceSearchFunction={() => {
                            this.setAdvanced();
                          }}
                          itemsByPage={10}
                          styles={styles}
                          filtrosPanel={filtros}
                          name="OrderList"
                          modalName="ui Modal body order list"
                          customer={this.props._customer}
                          user={this.props._user}
                          activePage={this.state.numberPage}
                          customAdd={
                            <ShowForRole
                              rol={this.props._rolId}
                              moduleAction={moduleActions.PEDIDO_ALTA}
                            >
                              {this.state.AddSO}
                            </ShowForRole>
                          }
                          options={{
                            xlsxPosition: "left",
                            pagination: true,
                            search: true,
                            panel: true,
                            downloads: {
                              xlsx: true,
                              pdf: false,
                            },
                            selectItems: false,
                            orderAttention: {
                              activeFilter: searchOnInit,
                              activeText: searchText,
                              search: true,
                              xlsx: true,
                            },
                            sheetName: this.props.t("orders"),
                            trigger: this.selectedOrder,
                            handleResCom: handleResCom,
                            searchKeys: [
                              "RefCustomer",
                              "Status",
                              "CustomerName",
                              "SupplierName",
                              "ConsigneeName",
                              "TransportMode",
                              "QTYOrdered",
                              "SOCreationDate",
                              "RequiredDateDestination",
                              "PromiseCargoReadyDate",
                              "EstCargoReadyDate",
                              "ActualCargoReadyDate",
                              "FinalDestinationArrivalDate",
                            ],
                          }}
                          cellType={"thick-rows"}
                        />
                      </Segment>
                    </Sidebar.Pusher>
                  </Sidebar.Pushable>
                </Suspense>
              </Col>
            </Row>
          )}
        </Card>
        {createModal({
          isModalOpen: modalOpen,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{textModal}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("po_management_detail_button_no"),
              onClick: this.toggle,
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_button_yes"),
              onClick: typeAction == 'duplicar' ? this.duplicatePo : typeAction == 'cancelar' ? this.cancelPo : this.deletePo,
              type: "primary",
            }
          ],
          onCancel: this.toggleCancel
        })}

        {createModal({
          isModalOpen: modalSuccess,
          titleModal: 'Success',
          type: 'success',
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("success_duplicated")}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("Ok"),
              onClick: () => this.props.history.push("/so-detail-view/" + duplicatedPoId),
              type: "primary",
            }
          ],
          onCancel: this.toggleCancel
        })}
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderListCommponent))
);
